var path = 'js/components/design-preview/design-preview.template.html';
var html = "<div class=main-loading-animation ng-if=$ctrl.loading></div> <div class=design-preview__image-wrapper> <img class=design-preview__image ng-src=\"{{$ctrl.image.data ? 'data:image/jpeg;base64,' + $ctrl.image.data : $ctrl.image.url}}\"> <div class=svg-wrapper> <svg class=design-preview__canvas></svg> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/design-preview/design-preview.template.html
// module id = 119
// module chunks = 0